import React from "react";

const IconWrapperComponent = ({ children, style }: any) => {
  return <div style={style}>{children}</div>;
};

export default IconWrapperComponent;
